import React from "react";
import { Box } from "grommet";
import { useLocation } from "react-router-dom";
import ArchivedPage from "./ArchivedPage";
import GuestsPage from "./GuestsPage";
import ReservationsPage from "./ReservationsPage";
import ReservationsTabs from "./ReservationsTabs";

export default function ReservationsHub() {
  const { pathname } = useLocation();

  const activePath = pathname.startsWith("/archived")
    ? "/archived"
    : pathname.startsWith("/expected")
      ? "/expected"
      : "/guests";

  const ActivePage =
    activePath === "/archived"
      ? ArchivedPage
      : activePath === "/expected"
        ? ReservationsPage
        : GuestsPage;

  return (
    <Box className="reservations-hub" fill>
      <ReservationsTabs activePath={activePath} />
      <Box className="reservations-tab-content" fill>
        <ActivePage />
      </Box>
    </Box>
  );
}
